import { css } from '@emotion/core'

export const SURFACE_COLOR = '#22505c'
export const PANEL_COLOR = '#16353c'
export const ACCENT_COLOR = '#c08b1f'
export const ON_SURFACE_COLOR = '#ffffff'
export const PRINT_FRAME_COLOR = '#ffffff'
export const PRINT_INNER_COLOR = '#3a3a3a'

// The flex chain, not `min-height`, is what fills the height: `min-height: 100%` resolves against
// a parent whose own height came from `min-height`, which browsers treat as indefinite.
export const surfaceCss = css`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: var(--heritage-portraits-available-height, 100%);
  background-color: ${SURFACE_COLOR};
  color: ${ON_SURFACE_COLOR};
`

export const sceneRootCss = css`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: var(--heritage-portraits-available-height, 100%);
  overflow: hidden;
  /* Without this, copy inherits the app's near-black body colour and vanishes into the photo. */
  color: ${ON_SURFACE_COLOR};
`

export const sceneBackdropCss = css`
  position: absolute;
  inset: 0;
  background-color: ${SURFACE_COLOR};
  background-size: cover;
  background-position: center;
  z-index: 0;
`

export const sceneScrimCss = css`
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgb(0 0 0 / 62%) 0%, rgb(0 0 0 / 34%) 45%, rgb(0 0 0 / 8%) 100%);
  z-index: 0;
`

export const sceneContentCss = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`

export const headlineCss = css`
  margin: 0;
  font-weight: 700;
  line-height: 1.08;
  letter-spacing: -0.01em;
  font-size: clamp(32px, 4.2vw, 76px);
  text-wrap: balance;
`

// Tokenised so PortraitScene's copy column can zero it against its own gap; parents that spend no
// vertical space of their own rely on the 16px fallback.
export const sublineCss = css`
  margin: var(--hp-subline-space, 16px) 0 0;
  font-size: clamp(15px, 1.25vw, 24px);
  line-height: 1.45;
  max-width: 34ch;
  opacity: 0.92;
`

export const printFrameCss = css`
  box-sizing: border-box;
  background-color: ${PRINT_FRAME_COLOR};
  padding: clamp(10px, 1.1vw, 22px);
  border-radius: 2px;
  box-shadow: 0 18px 48px rgb(0 0 0 / 35%);
`

export const printInnerCss = css`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-color: ${PRINT_INNER_COLOR};
`

const pillBaseCss = css`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  font-size: clamp(14px, 1vw, 18px);
  padding: clamp(10px, 0.9vw, 16px) clamp(18px, 1.6vw, 28px);
  min-height: 48px;
`

export const darkPillCss = css`
  ${pillBaseCss};
  background-color: #1d1d1b;
  color: #ffffff;
`

export const lightPillCss = css`
  ${pillBaseCss};
  background-color: #eeeeea;
  color: #1d1d1b;
`

// Opaque, not translucent: the scene scrim is a horizontal gradient down to 8% by the inline-end
// edge where this pill sits, so the pixels behind it are raw photograph. The ring is its boundary.
export const allowancePillCss = css`
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: clamp(12px, 0.85vw, 15px);
  font-weight: 600;
  background-color: #0d2226;
  color: ${ON_SURFACE_COLOR};
  box-shadow: 0 0 0 1px rgb(255 255 255 / 90%);
`
